import React from 'react';
import LinkFarmHandler from '../../../components/LinkFarmHandler/LinkFarmHandler';

export default ({ linkText, items, automationId }) => (
    <LinkFarmHandler
        category={linkText}
        items={items.map((i) => ({
            name: i.linkText,
            targetUrl: i.link.url,
            targetWindow: i.openInNewTab,
            imageUrl: i.image ? i.image.url : null,
            automationId: automationId || 'link-farm',
        }))}
    />
);
